import {useTableSeeker} from "ui-seeker/core";
import * as React from "react";
import {AppActionButton} from "app/@components/Base";
import {useActions} from "./@hooks";
import {useContextSelector} from "use-context-selector";
import {CommonFiltersSavedContext} from "../../../../../context";

export default function actionColumn(controller) {
    return {
        name: 'actions', label: 'Actions',
        options: {
            filter: false, sort: false,
            setCellHeaderProps: () => ({
                className: 'headTable bg-default',
                style: { textAlign: 'center', minWidth: '120px' }
            }),
            customBodyRenderLite: dataIndex => <Actions dataIndex={dataIndex} controller={controller} />
        }
    }
}
const Actions = ({dataIndex, controller}) => {
    const { getDataRow } = useTableSeeker()
    const {preset_key, default: isDefault, name } = getDataRow(dataIndex)

    const { removeDashboard, applyFilters, updateDashboard } = useActions(preset_key)
    const updatePrevState = useContextSelector(CommonFiltersSavedContext, ({updatePrevState}) => updatePrevState)
    const isEditing = useContextSelector(CommonFiltersSavedContext, ({state}) => state.isEditingName?.[preset_key] || false)

    return  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <AppActionButton
            onClick={() => updateDashboard(name, !isDefault)}
            icon={"star"}
            iconWeight={isDefault ? "fas" : "fal"}
            className="icon-filter-save-custom"
            label={"Set as default"}/>
        <AppActionButton onClick={() => applyFilters(controller)} icon={"filter"} label={"Apply Filters"} />
        <AppActionButton onClick={removeDashboard} icon={"trash"} label={"Remove"} />
        {isEditing && <AppActionButton
            className={"icon-editing-dashboard"}
            icon={"check"}
            label={"Save"}
        />}
        {!isEditing && <AppActionButton
            onClick={() => updatePrevState(prev => ({...prev, isEditingName: {...prev.isEditingName, [preset_key]: true}}))}
            icon={"pen"}
            label={"Edit"}
        />}
    </div>
}